export const styles = {
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
        marginBottom: -5,
    },
    fontSizeFiftin: {
        fontSize: 15
    },
    divider: {
        borderBottomWidth: 1,
        height: 5,
    },
    dwnldAssetMasterStyle: {
        marginTop: 2,
        marginBottom: 2,
        marginLeft: 13,
    },

    assetmasterCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
        marginTop: 5,
    },
    assetmasterCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },
    locContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
    },
    dwnldAssetMasterbttnStyle: {
        display: 'flex',
        justifyContent: { xs: 'flex-start', sm: 'center' },
        alignItems: 'center', justifyContent: 'flex-start'
    },

    fileStyle: {
        display: { lg: "flex", md: "flex" },
        gap: "1rem",
    },
    fileInputStyle: {
        border: "1px solid lightgrey",
        borderRadius: "5px",
    },
    buttonBox: {
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "16px",
        marginLeft: "1rem",
    },
    card: {
        backgroundColor: "#EEF2F7",
        padding: "0.5rem",
    },
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },

    cardTitle: {
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "16px",
        color: "#0160F1",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },
    deviderStyle: {
        marginRight: 2,
        marginLeft: 2,
        backgroundColor: "#c0c0c0",
        width: 2,
    },
};

export const boxSX = {
    textDecoration: "none",
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
        color: "darkblue",
    },
};


export default styles;



